import React from "react";

const Label = ({ children, ...props }) => {
  return (
    <label className="pb-1 pl-1 text-sm font-medium" {...props}>
      {children}
    </label>
  );
};

export default Label;
